const PORTFOLIO_TYPE_CONFIG = {
  DEFAULT_MEXICO: {
    availableFormats: ['PDF'],
    useDatePicker: false,
  },
};

const DEFAULT_CONFIG = {
  availableFormats: ['PDF', 'EXCEL'],
  useDatePicker: true,
};

const getPortfolioConfig = (portfolioType) => (
  PORTFOLIO_TYPE_CONFIG[portfolioType] || DEFAULT_CONFIG
);

export default getPortfolioConfig;
